import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=c65810f4&scoped=true"
import script from "./ProjectDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65810f4",
  null
  
)

export default component.exports